import { Box, Container, Stack } from '@mui/material';
import React, { useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import Colors from '../../colors';
import SingleTextInputModal from '../modals/SafetyTailgateModals/SingleTextInputModal';

function AddCustom({ modalLabel, inputLabel, dataCallback }) {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <>
            <Stack
                sx={{
                    background: Colors.white,
                    textAlign: 'center',
                    justifyContent: 'center',
                    paddingTop: '15px',
                    paddingBottom: '5px',
                    boxShadow: '0px 0px 25px -2px rgba(0, 0, 0, 0.1)',
                    minHeight: '100px'
                }} >

                <Box onClick={() => setIsVisible(true)}>
                    <Container>
                        <AddIcon />
                    </Container>
                    <Container>
                        Add Custom
                    </Container>
                </Box>

            </Stack>
            <SingleTextInputModal
                modalLabel={modalLabel}
                inputLabel={inputLabel}
                isVisible={isVisible}
                defaultValue={''}
                setIsVisible={setIsVisible}
                dataCallback={dataCallback} />
        </>

    )
}

export default AddCustom;